import { formatMoney } from '@shopify/theme-currency';

export default {
  create(cents) {
    const template = document.getElementById('template-money').content;
    const moneyFragment = template.cloneNode(true);
    const moneyEl = moneyFragment.querySelector('[data-money]');
    const moneyFormatted = formatMoney(cents, PXUTheme.money_format);

    moneyEl.innerHTML = moneyFormatted;

    return moneyFragment;
  },
  createRange(centsMin, centsMax) {
    const template = document.getElementById('template-money-range').content;
    const moneyFragment = template.cloneNode(true);
    const moneyMinEl = moneyFragment.querySelector('[data-money-min]');
    const moneyMaxEl = moneyFragment.querySelector('[data-money-max]');
    const moneyMinFormatted = formatMoney(centsMin, PXUTheme.money_format);
    const moneyMaxFormatted = formatMoney(centsMax, PXUTheme.money_format);

    moneyMinEl.innerHTML = moneyMinFormatted;
    moneyMaxEl.innerHTML = moneyMaxFormatted;

    return moneyFragment;
  },
};
